<template>
    <v-form ref="form" autocomplete="off" @submit.prevent="save">
        <v-row>
            <v-col cols="12" sm="6">
                <marca-combobox v-model="form.marca" :input-errors="inputErrors" :disabled="disableMarca" />
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field prepend-icon="emoticon-cool-outline" name="nombre" v-model="form.nombre"
                    :label="$t('modelo.labels.nombre')" :placeholder="$t('modelo.labels.nombre')"
                    :error="hasInputErrors('nombre')" :error-messages="getInputErrors('nombre')" color="secondary"
                    :rules="required"></v-text-field>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>

import { InputErrorsByProps, RequiredRule } from '@dracul/common-frontend'

import MarcaCombobox from "./MarcaCombobox";





export default {
    name: "ModeloForm",
    mixins: [InputErrorsByProps, RequiredRule],
    components: { MarcaCombobox, },
    props: {
        value: {
            type: Object,
            required: true
        },
        disableMarca: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        form: {
            get() { return this.value },
            set(val) { this.$emit('input', val) }
        }
    },
    watch: {
        form: {
            handler(newVal) {
                this.$emit('input', newVal)
            },
            deep: true
        }
    },
    methods: {
        validate() {
            return this.$refs.form.validate()
        }
    },
    data() {
        return {

        }
    }
}
</script>

<style scoped></style>
